module.exports = __webpack_public_path__ + "img/5-4.ee2e215b.jpg";